const zoomBox = document.createElement("div");
zoomBox.classList.add("zoom-box");
document.body.appendChild(zoomBox);

const lens = document.createElement("div");
lens.classList.add("lens");

document.querySelectorAll('.image-container img').forEach(img => {
    img.addEventListener("mouseenter", function (e) {

        img.parentElement.appendChild(lens);
        lens.style.display = "block";
        
        zoomBox.style.display = "block";
        zoomBox.style.backgroundImage = `url(${img.parentElement.getAttribute("data-image")})`;
        zoomBox.style.left = `${img.getBoundingClientRect().left + img.clientWidth + 10}px`;
        if(img.getBoundingClientRect().top > 0){
            zoomBox.style.top = `${img.getBoundingClientRect().top}px`;
        }
        else{
            zoomBox.style.top = '120px';
        }

        if(img.getBoundingClientRect().top > (window.innerHeight - 200)){
            zoomBox.style.top = null;
            zoomBox.style.bottom = '80px';
        }
    });

    img.addEventListener("mousemove", function (e) {
       

        const rect = img.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const zoomScale = 2; // Adjust zoom level


        // Prevent lens from going out of bounds
        let lensX = x - lens.clientWidth / 2;
        let lensY = y - lens.clientHeight / 2;

        if (lensX < 0) lensX = 0;
        if (lensY < 0) lensY = 0;
        if (lensX > rect.width - lens.clientWidth) lensX = rect.width - lens.clientWidth;
        if (lensY > rect.height - lens.clientHeight) lensY = rect.height - lens.clientHeight;

        lens.style.left = lensX + "px";
        lens.style.top = lensY + "px";

        zoomBox.style.backgroundSize = `${rect.width * zoomScale}px ${rect.height * zoomScale}px`;
        zoomBox.style.backgroundPosition = `-${x * zoomScale - zoomBox.clientWidth / 2}px -${y * zoomScale - zoomBox.clientHeight / 2}px`;
        
    });

    img.addEventListener("mouseleave", function () {
        zoomBox.style.display = "none";
        lens.style.display = "none";
    });
});